/**
 * Kıdem Tazminatı Hesaplama Engine
 * 1475 sayılı Eski İş Kanunu Geçici Md. 6 + 4857 sayılı İş Kanunu
 * 2026 Ocak-Haziran Dönemi: Tavan 64.948,77 TL
 */

export const YILI = 2026;
export const BRUT_ASGARI_UCRET = 33_030;
export const KIDEM_TAZMINATI_TAVANI = 64_948.77;
export const DAMGA_VERGISI_ORAN = 0.00759;

export interface KidemGirdi {
  brutMaas: number;
  calismaYili: number;
  calismaAyi: number;
  calismaGunu: number;
}

export interface KidemSonuc {
  brutMaas: number;
  tavanUygulandi: boolean;
  hesaplamaBrutMaas: number; // tavan uygulanmışsa tavan
  toplamGun: number;
  toplamYil: number;
  kalanAy: number;
  kalanGun: number;
  brutKidemTazminati: number;
  damgaVergisi: number;
  netKidemTazminati: number;
}

export function formatTL(value: number): string {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function hesaplaKidem(girdi: KidemGirdi): KidemSonuc {
  const brutMaas = Math.max(0, girdi.brutMaas || 0);
  const yil = Math.max(0, girdi.calismaYili || 0);
  const ay = Math.max(0, girdi.calismaAyi || 0);
  const gun = Math.max(0, girdi.calismaGunu || 0);

  const toplamGun = yil * 365 + ay * 30 + gun;
  const toplamYil = toplamGun / 365;

  const kalanAy = Math.floor((toplamGun % 365) / 30);
  const kalanGun = (toplamGun % 365) % 30;

  // Tavan kontrolü
  const tavanUygulandi = brutMaas > KIDEM_TAZMINATI_TAVANI;
  const hesaplamaBrutMaas = Math.min(brutMaas, KIDEM_TAZMINATI_TAVANI);

  // Kıdem tazminatı = Her tam yıl için 30 günlük ücret (kısmi yıl da orantılı)
  const brutKidemTazminati = hesaplamaBrutMaas * toplamYil;
  const damgaVergisi = brutKidemTazminati * DAMGA_VERGISI_ORAN;
  const netKidemTazminati = brutKidemTazminati - damgaVergisi;

  return {
    brutMaas,
    tavanUygulandi,
    hesaplamaBrutMaas,
    toplamGun,
    toplamYil,
    kalanAy,
    kalanGun,
    brutKidemTazminati,
    damgaVergisi,
    netKidemTazminati,
  };
}
